import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from 'common/method/handleNotificationAlert'

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
    SelectPledge_customer: "SelectPledge_customer [Action]",
    SelectPledge_customerLoading: "SelectPledge_customerLoading [Action]",
    SelectPledge_customerAsync: "SelectPledge_customerAsync [Action]",
};
const inistiaState = {
    data: [],
    loading: false
};

export const Select_Pledge_customer_reducer = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.SelectPledge_customer:
            return {
                ...state,
                data: payload,
            };
        case actionTypes.SelectPledge_customerLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.SelectPledge_customerLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "pledge",
        method_type: "pledge_customer",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }
        
        yield put({ type: actionTypes.SelectPledge_customer, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.SelectPledge_customerLoading, payload: false })

    }
}

export function* selectPledgeCustomert() {
    yield takeLatest(actionTypes.SelectPledge_customerAsync, handleWorker);
}
